package bm

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.html.classes
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onMouseOutFunction
import kotlinx.html.js.onMouseOverFunction
import model.*
import org.w3c.dom.HTMLElement
import org.w3c.xhr.XMLHttpRequest
import react.RBuilder
import react.dom.*
import react.setState
import util.getCommitUrl
import util.isMerge
import util.timeBetweenDisplay
import util.timeSinceDisplay
import kotlin.math.max
import kotlin.math.min

fun RBuilder.renderer(app: App, projects: Array<Project>, isRestarting: Boolean, configFailed: Boolean) {

    val page = app.state.pageToDisplay
    header(app, isRestarting, app.props.restartingMessage, app.props.pages, configFailed, app.props.configFailedMessage)

    if (page.uppercase() == "CI") {
        renderCI(projects, app, isRestarting)
    } else if (page.uppercase() == "CD") {
        renderCD(projects, app)
    }

    p(classes = "refresh") {
        a(href = withGoogleAccount(buildmanagerBackendUrl, app.state.result.currentUser), target = "_blank") {
            +"buildmanager-backend logs"
        }
    }

    app.state.testRunsTooltip?.let { renderTestRunsTooltip(it) }
}

private fun RBuilder.renderCI(projects: Array<Project>, app: App, isRestarting: Boolean) {
    div(classes = "projects-container") {
        div {
            projects.forEach { project ->
                div {
                    projectTitle(project)
                    div(classes = "projects-header CI") {
                        div(classes = "branch") { +"Branch" }
                        div(classes = "status") { +"Status" }
                        div(classes = "docker") { +"Version" }
                        div(classes = "date") { +"Date" }
                        div(classes = "time") { +"Time" }
                        div(classes = "avg-time") { +"Avg. time" }
                        div(classes = "committer") { +"Committer" }
                        div(classes = "message") { +"Commit message" }
                        div { +"Actions" }
                    }
                }

                project.branches.forEach { branch ->
                    val b = branch.buildResult
                    div(classes = "project") {
                        attrs.classes = setOf("project " + app.state.pageToDisplay)

                        renderStatusBorder(b.status)
                        div(classes = "project--item mouseover") {
                            attrs["data-tooltip"] = "Click here to see more details"
                            img(classes = "icn", alt = "branch icon", src = "images/icn-branch.svg") {}
                            div {
                                attrs["title"] = branch.name // in full, should it not fit
                                +branch.name
                            }
                            attrs.onClickFunction = {
                                app.setState {
                                    if (projectToDisplay == project.name && branchToDisplay == branch.name) {
                                        projectToDisplay = ""
                                        branchToDisplay = ""
                                    } else {
                                        projectToDisplay = project.name
                                        branchToDisplay = branch.name
                                    }
                                }
                            }
                        }
                        div(classes = "project--item status mouseover") {
                            attrs["data-tooltip"] = "Click here to open GCP console and check logs"
                            attrs.onClickFunction = { window.open(b.logUrl) }
                            div { renderStatus(b.status, b.subStatus) }
                        }
                        div(classes = "project--item version mouseover") {
                            val tag = b.version
                            val fullTag = displayedTag(b)
                            val isValidTag = tag.isNotBlank()
                            img(classes = "icn", alt = "docker icon", src = "images/icn-docker.svg") {}
                            if (isValidTag) {
                                attrs["data-tooltip"] = "Click here to copy version to clipboard"
                            }
                            div(classes = "version-line") {
                                if (isValidTag) renderTag(branch.name, fullTag)
                                renderTestBadges(app, tag)
                            }
                            if (isValidTag) attrs.onClickFunction = { event -> copyToClipboard(tag, event.currentTarget as HTMLElement) }
                        }
                        div(classes = "project--item") {
                            img(classes = "icn", alt = "time icon", src = "images/icn-date.svg") {

                            }
                            div { +b.createTime }
                        }
                        val time = if (b.status == "WORKING") timeSinceDisplay(b.createEpoch) else timeBetweenDisplay(b.createEpoch, b.finishEpoch)
                        div(classes = "project--item") {
                            img(classes = "icn", alt = "time icon", src = "images/icn-timer.svg") {}
                            div { +time }
                        }
                        div(classes = "project--item") {
                            img(classes = "icn", alt = "time icon", src = "images/icn-avg_time.svg") {}
                            div { +branch.meanSuccessDuration }
                        }
                        div(classes = "project--item") {
                            img(classes = "icn", alt = "time icon", src = "images/icn-user.svg") {}
                            div { +(b.commits.firstOrNull()?.committerName ?: "") }
                        }
                        div(classes = "project--item message") {
                            img(classes = "icn", alt = "time icon", src = "images/icn-quote.svg") {}
                            val failedCommit = b.commits.firstOrNull()
                            if (failedCommit != null) {
                                div {
                                    val url = getCommitUrl(project.cloneUrl, failedCommit.commitId)
                                    if (url.isNotBlank()) {
                                        a(href = url, target = "_blank") {
                                            +(failedCommit.commitMessage)
                                        }
                                    } else {
                                        +(failedCommit.commitMessage)
                                    }
                                }
                            }
                        }

                        div(classes = "project--item actions") {
                            if (!isRestarting && (b.status == "FAILURE" || b.status == "TIMEOUT")) {
                                button {
                                    attrs.onClickFunction = {
                                        val xhttp = XMLHttpRequest()
                                        sendRequest(app.props, xhttp, "GET", "/retryLastBuild?project=${project.name}&branch=${branch.name}")
                                        xhttp.onreadystatechange = {
                                            if (xhttp.readyState == 4.toShort() && xhttp.status == 200.toShort()) {
                                                val result: Boolean = JSON.parse(xhttp.responseText)
                                                if (result) window.alert("Build triggered! It will be displayed as 'WORKING' on next refresh.")
                                                else window.alert("Build not triggered :(")
                                            }
                                        }
                                    }
                                    +"Retry"
                                }
                            }
                        }

                        div(classes = "more-info-s") {
                            if (project.name == app.state.projectToDisplay && branch.name == app.state.branchToDisplay) {
                                attrs.classes = setOf("more-info-s display")
                                displayBranch(app, project, branch, app.state.profile)
                            }
                        }
                    }
                }
            }
        }
    }
}

// The tooltip of a test badge, drawn over everything: the cells clip what overflows them
data class TestRunsTooltip(val runs: List<TestRun>, val left: Double, val top: Double, val bottom: Double)

private val runningStatuses = setOf("preparing", "running", "cancelling")

private fun TestRun.isRunning() = status in runningStatuses

// Red as soon as a test failed, green when they all passed
private fun TestRun.colorClass() = when {
    totals.failed > 0 || status == "failed" -> "failure"
    isRunning() -> "working"
    status == "passed" -> "success"
    status == "cancelled" -> "cancelled"
    status == "aborted" || status == "error" -> "timeout"
    else -> "default"
}

// e.g. "✓ 27 ✗ 1", or what became of a run that ran no test (its record only tells the counts once it ended)
private fun TestRun.summary() = when {
    isRunning() -> "running…"
    totals.completed == 0 -> status
    else -> "✓ ${totals.passed + totals.flaky}" + when {
        totals.failed > 0 -> " ✗ ${totals.failed}"
        status != "passed" -> " · $status"
        else -> ""
    }
}

private fun TestRun.duration() = if (isRunning()) "for " + timeSinceDisplay(startEpoch) else timeBetweenDisplay(startEpoch, endEpoch)

// A badge for the latest e2e test run of [version] on each host it ran on, the earlier ones in its tooltip
private fun RBuilder.renderTestBadges(app: App, version: String) {
    val testRuns: Array<TestRun>? = app.state.result.testRuns // none from a backend that doesn't send them
    if (version.isBlank() || testRuns == null) return
    testRuns.filter { it.version == version }.groupBy { it.hostName }.values.forEach { renderTestBadge(app, it) }
}

// Opens the report of the latest of [runs] (or its files), and tells more of them under the mouse
private fun RBuilder.renderTestBadge(app: App, runs: List<TestRun>) {
    val run = runs.first()
    val url = run.reportUrl.ifBlank { withGoogleAccount(run.folderUrl, app.state.result.currentUser) }
    a(href = url, target = "_blank", classes = "test-badge ${run.colorClass()}" + if (run.partial) " partial" else "") {
        attrs.onClickFunction = { event -> event.stopPropagation() } // neither copies the version, nor opens the details of the row
        attrs.onMouseOverFunction = { event ->
            val rect = (event.currentTarget as HTMLElement).getBoundingClientRect()
            app.setState { testRunsTooltip = TestRunsTooltip(runs, rect.left, rect.top, rect.bottom) }
        }
        attrs.onMouseOutFunction = { app.setState { testRunsTooltip = null } }
        +run.summary()
    }
}

private fun RBuilder.renderTestRunsTooltip(tooltip: TestRunsTooltip) {
    val run = tooltip.runs.first()
    val totals = run.totals
    div(classes = "test-tooltip") {
        attrs.jsStyle {
            left = "${max(8.0, min(tooltip.left, window.innerWidth - 488.0))}px"
            // below the badge, above it in the lower part of the window
            if (tooltip.bottom < window.innerHeight * 0.6) top = "${tooltip.bottom + 6}px" else bottom = "${window.innerHeight - tooltip.top + 6}px"
        }
        div(classes = "test-tooltip-title") { +"E2E tests of ${run.version} on ${run.hostName}" }
        div(classes = "t-${run.colorClass()}") {
            b { +run.status.uppercase() }
            if (!run.isRunning()) {
                +(" — ${totals.passed} passed, ${totals.failed} failed" + (if (totals.flaky > 0) ", ${totals.flaky} flaky" else "") +
                        (if (totals.skipped > 0) ", ${totals.skipped} skipped" else "") + " (${totals.total} tests)")
            }
        }
        div(classes = "muted") { +listOf(run.startTime, run.duration(), "by ${run.startedBy}").filter { it.isNotBlank() }.joinToString(" · ") }
        div(classes = "line") { +(if (run.scope.isBlank()) "All the tests" else (if (run.partial) "Some tests only: " else "") + run.scope) }
        if (run.statusDetail.isNotBlank()) div(classes = "line") { +run.statusDetail }
        if (run.labVersion.isNotBlank() && run.labVersion != run.version) div(classes = "line muted") { +"Lab ${run.labVersion}" }
        if (run.devices.isNotEmpty()) {
            h5 { +"Devices" }
            run.devices.forEach { device ->
                div(classes = "line") {
                    +device.name
                    if (device.model.isNotBlank()) span(classes = "muted") { +" ${device.model}" }
                    if (!run.isRunning()) +(": ✓ ${device.totals.passed + device.totals.flaky}" + if (device.totals.failed > 0) " ✗ ${device.totals.failed}" else "")
                }
            }
        }
        if (run.failureCount > 0) {
            h5 { +"Failures (${run.failureCount})" }
            run.failures.forEach { failure ->
                div(classes = "line") {
                    span(classes = "t-failure") { +"✗ " }
                    +"${failure.test} "
                    span(classes = "muted") { +"on ${failure.device}: ${failure.error}" }
                }
            }
            if (run.failureCount > run.failures.size) div(classes = "muted") { +"… and ${run.failureCount - run.failures.size} more" }
        }
        if (run.warningCount > 0) {
            h5 { +"Warnings (${run.warningCount})" }
            run.warnings.forEach { warning -> div(classes = "line muted") { +warning } }
            if (run.warningCount > run.warnings.size) div(classes = "muted") { +"… and ${run.warningCount - run.warnings.size} more" }
        }
        if (tooltip.runs.size > 1) {
            h5 { +"Earlier runs of this version" }
            tooltip.runs.drop(1).forEach { earlier ->
                div(classes = "line") {
                    span(classes = "t-${earlier.colorClass()}") { +earlier.summary() }
                    +(" · ${earlier.startTime} · ${earlier.startedBy}" + if (earlier.partial) " · some tests only" else "")
                }
            }
        }
        div(classes = "test-tooltip-footer muted") { +(if (run.reportUrl.isNotBlank()) "Click to open its report" else "Click to open its files") }
    }
}

external fun encodeURIComponent(component: String): String

/*
 * [url] of the Google Cloud console, opened with the Google account of [user], the email the user logged in to taktik.ci
 * with, rather than with the browser's first account (Google picks an account by its email only, not by its domain)
 */
private fun withGoogleAccount(url: String, user: String) =
    if (user.isBlank()) url else url + (if (url.contains('?')) "&" else "?") + "authuser=" + encodeURIComponent(user)

/* Copies [text] to the clipboard, and says so for a moment in the tooltip of [element], the one that offers the copy */
private fun copyToClipboard(text: String, element: HTMLElement) {
    val tooltip = element.getAttribute("data-tooltip")
    fun tell(message: String) {
        element.setAttribute("data-tooltip", message)
        window.setTimeout({ if (tooltip != null) element.setAttribute("data-tooltip", tooltip) }, 1500)
    }
    val clipboard = window.navigator.asDynamic().clipboard
    if (clipboard == null) tell("Copy failed: no clipboard access here")
    else clipboard.writeText(text).then({ _: dynamic -> tell("Copied ✓") }, { _: dynamic -> tell("Copy failed") })
}

private fun RBuilder.renderCD(projects: Array<Project>, app: App) {
    div(classes = "projects-container") {
        div {
            projects.forEach { project ->
                if (project.branches.any { it.deployments.isNotEmpty() }) {
                    projectTitle(project)
                    div {
                        div(classes = "projects-header") {
                            div(classes = "branch") { +"Branch" }
                            div { +"Release" }
                            div { +"URL" }
                            div(classes = "status") { +"Status" }
                            div { +"Current tag" }
                            div { +"Last deployment" }
                            div { +"Last tag deployed" }
                            div { +"In charge" }
                        }
                    }
                }

                project.branches.forEach { branch ->
                    branch.deployments.forEach { deployment ->
                        div(classes = "project") {
                            attrs.classes = setOf("project mouseover " + app.state.pageToDisplay)
                            attrs.onClickFunction = {
                                app.setState {
                                    releaseToDisplay = if (releaseToDisplay == deployment.release) {
                                        ""
                                    } else {
                                        deployment.release
                                    }
                                }
                            }

                            val subStatus = computeSubStatus(deployment.podStatuses, deployment.paused)

                            renderStatusBorder(subStatus)
                            div(classes = "project--item") {
                                img(classes = "icn", alt = "branch icon", src = "images/icn-branch.svg") {}
                                div {
                                    +branch.name
                                }
                            }
                            div(classes = "project--item") {
                                div {
                                    +deployment.release
                                }
                            }

                            div(classes = "project--item") {
                                div(classes = "available inline") {
                                    deployment.hostNames.forEach { hostName ->
                                        a(href = "https://$hostName", target = "_blank") { +hostName }
                                    }
                                }
                            }

                            div(classes = "project--item") {
                                div {
                                    renderStatus(subStatus, "")
                                }
                            }

                            div(classes = "project--item") {
                                div(classes = "version-line") {
                                    span { +deployment.lastTagSuccessfullyDeployed }
                                    renderTestBadges(app, deployment.lastTagSuccessfullyDeployed)
                                }
                            }

                            val upgradeMessage = if (deployment.upgradeRequired) " (upgrade required)" else ""
                            div(classes = "project--item") {
                                div {
                                    val text = "${deployment.releaseStatus}$upgradeMessage"
                                    renderStatus(text)
                                }
                            }

                            div(classes = "project--item") {
                                div {
                                    val different = deployment.lastTagDeployed != deployment.lastTagSuccessfullyDeployed
                                    val text = if (different) deployment.lastTagDeployed else if (deployment.lastTagDeployed.isBlank()) "" else "current"
                                    val suffix = if (deployment.fixedTag.isBlank()) "" else {
                                        if (deployment.lastTagSuccessfullyDeployed == deployment.fixedTag || deployment.lastTagDeployed == deployment.fixedTag) {
                                            " (fixed)"
                                        } else {
                                            " (fixed is ${deployment.fixedTag})"
                                        }
                                    }
                                    +(text + suffix)
                                }
                            }

                            div(classes = "project--item") {
                                div {
                                    +deployment.personInCharge.let {
                                        if (it.contains("@")) it.substringBefore("@").uppercase()
                                        else it
                                    }
                                }
                            }

                            div(classes = "more-info-s") {
                                if (deployment.release == app.state.releaseToDisplay) {
                                    attrs.classes = setOf("more-info-s display")
                                    displayRelease(deployment.podStatuses, app.state.result.currentUser)
                                    deployButtons(app, deployment.release)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun computeSubStatus(pods: Array<PodStatus>, paused: Boolean): String {
    val empty = pods.isEmpty()
    var init = false
    var pending = false
    var error = false
    var crash = false
    var otherNotRunning = false

    var ready = true

    val nRunning = pods.count { it.state.contains("Running") }
    val nRestarts = pods.filter { it.restarts > 0 }.sumOf { it.restarts }

    pods.forEach { pod ->
        when {
            pod.state.contains("PodInitializing") -> init = true
            pod.state.contains("Pending") -> pending = true
            pod.state.contains("Error") -> error = true
            pod.state.contains("CrashLoopBackOff") -> crash = true
            !pod.state.contains("Running") -> otherNotRunning = true
        }
        if (!pod.ready) ready = false
    }
    var output = ""
    if (paused) output = noPodPaused
    else if (empty) output = noPod
    else if (crash) output = "CrashLoopBackOff"
    else if (error) output = "Error"
    else if (pending) output = "Pending"
    else if (init) output = "Initializing"
    else if (!otherNotRunning) output = "$nRunning pods running"
    output += if (ready) "" else notRdy
    output += if (nRestarts <= 0) "" else " - $nRestarts restarts"
    return output
}

private fun RBuilder.displayRelease(pods: Array<PodStatus>, user: String) {
    div {
        pods.forEach { pod ->
            val notReady = if (!pod.ready) " (not ready)" else ""
            li(classes = "small") {
                a(href = withGoogleAccount("https://console.cloud.google.com/logs/query;query=resource.type%3D%22k8s_container%22%0Aresource.labels.cluster_name%3D%22$clusterName%22%0Aresource.labels.namespace_name%3D%22${pod.namespace}%22%0Aresource.labels.pod_name%3D%22${pod.name}%22?project=$projectName", user), target = "_blank") {
                    +pod.name
                }
                val restarts = if (pod.restarts >= 0) "${pod.restarts} restarts" else ""
                + ": ${pod.state}$notReady, $restarts${pod.startTime?.let { ", up for " + timeSinceDisplay(it) } ?: ""}"
            }
        }
    }
}

private fun RBuilder.deployButtons(app: App, releaseName: String) {
    div {
        div {
            button {
                attrs.onClickFunction = {
                    val xhttp = XMLHttpRequest()
                    sendRequest(app.props, xhttp, "GET", "/deploy?release=$releaseName")
                    xhttp.onreadystatechange = {
                        if (xhttp.readyState == 4.toShort() && xhttp.status == 200.toShort()) {
                            val result: Boolean = JSON.parse(xhttp.responseText)
                            if (result) window.alert("Redeploy done.")
                            else window.alert("Redeploy NOT done :(")
                        }
                    }
                }
                +"Redeploy $releaseName"
            }
        }
        div {
            button {
                attrs.onClickFunction = {
                    val xhttp = XMLHttpRequest()
                    sendRequest(app.props, xhttp, "GET", "/deploy?release=$releaseName&coldUpgrade=true")
                    xhttp.onreadystatechange = {
                        if (xhttp.readyState == 4.toShort() && xhttp.status == 200.toShort()) {
                            val result: Boolean = JSON.parse(xhttp.responseText)
                            if (result) window.alert("Cold upgrade done.")
                            else window.alert("Cold upgrade NOT done :(")
                        }
                    }
                }
                +"Cold upgrade $releaseName"
            }
        }
    }
}

private fun RBuilder.header(app: App, isRestarting: Boolean, restartMessage: String, pages: Array<String>, configFailed: Boolean, configFailedMessage: String) {
    div(classes = "header") {
        div {
            table {
                tr {
                    pages.forEach { page ->
                        td {
                            attrs.classes = setOf("mouseover")
                            attrs.onClickFunction = {
                                app.setState {
                                    pageToDisplay = page
                                }
                            }
                            img(classes = "logo", alt = "taktik logo", src = "images/taktik-logo.svg") {}
                            span(classes = "ci") { +page }
                            if (page == app.state.pageToDisplay) attrs.classes = setOf("active")

                        }
                    }
                }
            }
        }
        if (isRestarting) h4 { +restartMessage }
        else if (configFailed) h4 { +configFailedMessage }
    }
}

private fun RBuilder.projectTitle(project: Project) {
    div(classes = "project-title") {
        when (project.name) {
            "Flowr" -> img(classes = "project-logo", alt = "flowr logo", src = "images/logo-flowr.png") {}
            "Ozone" -> img(classes = "project-logo", alt = "ozone logo", src = "images/logo-ozone.png") {}
            else -> +project.name
        }
    }
}

private fun RBuilder.displayBranch(app: App, p: Project, b: Branch, profile: String) {
    div {
        h3 { +"Branch ${b.name}" }
        previousBuilds(app, p, b)

        /* DISPLAY FAILURE-RELATED CONTENT */
        if (b.buildResult.status == "FAILURE" || b.buildResult.status == "TIMEOUT") {
            committersToBlame(p, b.buildResult)
            errorMessage(b.buildResult)
        } else if (b.buildResult.status != "SUCCESS") {
            val failed = try {
                b.oldBuilds.last { it.status == "SUCCESS" || it.status == "FAILURE" }
            } catch (e: Exception) {
                null
            }
            if (failed != null && failed.status == "FAILURE") {
                committersToBlame(p, failed)
                errorMessage(failed)
            }
        }

        /* DISPLAY VARIOUS ADDITIONAL CONTENT */
        if (profile == Profiles.FLOWR) {
            val urlBranch = getBranchForUrl(b.name)
            if (p.name == "Flowr" && b.name != "release/5.1") {
                val docUrl = "https://storage.googleapis.com/taktik-flowr-doc/$urlBranch/d5t5jz868jqv2k928qwapqhtagzf2v/html/index.html"
                div {
                    h3(classes = "verticalPadding") { +"Flowr doc: " }
                    div(classes = "available") {
                        +"Available at "
                        a(href = docUrl, target = "_blank") { +"this URL" }
                    }
                }
                val services = listOf("agent", "airport", "backend", "common", "epg", "traffic", "train", "weather", "proxy")
                div {
                    h3(classes = "verticalPadding") { +"Configuration properties: " }
                    div(classes = "available") {
                        services.forEach {
                            val metadataUrl = "https://storage.googleapis.com/taktik-metadata/flowr/$urlBranch/skabtf3rptbbs93d5e2972zux42sap/flowr-$it-metadata.html"
                            a(href = metadataUrl, target = "_blank") { +"$it " }
                        }
                    }
                }
            }
            if (p.name == "qi") {
                val docUrl = "https://storage.googleapis.com/taktik-doc/qi/$urlBranch/LVoCTiXbYm9tfpyDvaakNw9uMIPEHo/index.html"
                div {
                    div(classes = "verticalPadding available") {
                        a(href = docUrl, target = "_blank") { +"QI doc" }
                    }
                }
            }
        }
    }
}

private fun getBranchForUrl(branchName: String) = branchName.replace("/", "-").replace(".", "_")

// The version, after the image name when the backend knows it
private fun displayedTag(buildResult: BuildResult) =
    if (buildResult.dockerImageName.isNotBlank()) buildResult.dockerImageName + ":" + buildResult.version else buildResult.version

private fun RBuilder.renderStatus(status: String, secondaryStatus: String = "") {
    val display = status + if (secondaryStatus.isNotBlank()) " ($secondaryStatus)" else ""
    when {
        status.startsWith("SUCCESS") || status.endsWith("running") && !status.startsWith(noPod) && !status.startsWith(noPodPaused) -> span(classes = "status-span success") { +display }
        status.startsWith("WORKING") || status.startsWith("Initializing") || status.contains(notRdy) -> span(classes = "status-span working") { +display }
        status.startsWith("TIMEOUT") || status.startsWith("QUEUED") || status.startsWith("Pending") || status.startsWith(noPod) || status.startsWith(noPodPaused) -> span(classes = "status-span timeout") { +display }
        status.startsWith("FAILURE") || status.startsWith("Error") || status.startsWith("CrashLoopBackOff") -> span(classes = "status-span failure") { +display }
        status.startsWith("CANCELLED") -> span(classes = "status-span cancelled") { +display }
        else -> span(classes = "status-span default") { +display }
    }
}

private fun RBuilder.renderStatusBorder(status: String) {
    when {
        status == "SUCCESS" || status.endsWith("running") && !status.startsWith(noPod) && !status.startsWith(noPodPaused) -> span(classes = "status-border status-border--success") { }
        status == "WORKING" || status.startsWith("Initializing") || status.contains(notRdy) -> span(classes = "status-border status-border--working") { }
        status == "TIMEOUT" || status == "QUEUED" || status.startsWith("Pending") || status.startsWith(noPod) || status.startsWith(noPodPaused) -> span(classes = "status-border status-border--timeout") { }
        status == "FAILURE" || status.startsWith("Error") || status.startsWith("CrashLoopBackOff") -> span(classes = "status-border status-border--failure") { }
        status == "CANCELLED" -> span(classes = "status-border status-border--cancelled") { }
        else -> span(classes = "status-border status-border--default") { }
    }
}

private fun RBuilder.renderTag(branch: String, tag: String) {
    when {
        branch.startsWith("release/") && branch.endsWith("-rc") -> span(classes = "rcTag") { +tag }
        branch.startsWith("release/") || branch == "master" -> span(classes = "releaseTag") { +tag }
        branch == "develop" -> span(classes = "developTag") { +tag }
        branch.startsWith("bugfix/") || branch.startsWith("hotfix/") || branch.startsWith("feature/") -> span(classes = "featureTag") { +tag }
        else -> span(classes = "defaultTag") { +tag }
    }
}

private fun RBuilder.previousBuilds(app: App, p: Project, b: Branch) {
    if (b.oldBuilds.isNotEmpty()) {
        p { +"Previous builds:" }
        ul {
            b.oldBuilds.toList().asReversed().forEach { oldBuildResult ->
                val duration = " (" + (if (oldBuildResult.status == "WORKING") timeSinceDisplay(oldBuildResult.createEpoch) + "..." else timeBetweenDisplay(oldBuildResult.createEpoch, oldBuildResult.finishEpoch)) + ")"
                val by = if (oldBuildResult.commits.isEmpty()) "" else {
                    val name = oldBuildResult.commits[0].committerName
                    val message = oldBuildResult.commits[0].commitMessage
                    " by $name" + (if (isMerge(message)) " (merge)" else "")
                }
                li {
                    div(classes = "inline") {
                        div(classes = "mouseover") {
                            attrs["data-tooltip"] = "Click here to open GCP console and check logs"
                            attrs.onClickFunction = { window.open(oldBuildResult.logUrl) }
                            div { renderStatus(oldBuildResult.status, oldBuildResult.subStatus) }
                        }
                        +": ${oldBuildResult.createTime}$duration $by"
                        if (oldBuildResult.status == "SUCCESS") {
                            span(classes = "margins") { +"-" }

                            // the version is shown even when its commit can't be linked to, e.g. a repository on another host
                            if (oldBuildResult.version.isNotBlank()) {
                                val tag = displayedTag(oldBuildResult)
                                val url = getCommitUrl(p.cloneUrl, oldBuildResult.commitSha)
                                if (url.isNotBlank()) {
                                    div(classes = "mouseover") {
                                        attrs["data-tooltip"] = "Click here to see corresponding commit"
                                        attrs.onClickFunction = { window.open(url) }
                                        div { renderTag(b.name, tag) }
                                    }
                                } else {
                                    div { renderTag(b.name, tag) }
                                }
                            }

                            renderTestBadges(app, oldBuildResult.version)
                        }
                    }
                }
            }

        }
    } else {
        p { +"No previous build." }
    }
}

private fun RBuilder.committersToBlame(project: Project, buildResult: BuildResult) {
    p { +"Blame them: " }
    ul {
        buildResult.commits.forEach {
            li {
                val url = getCommitUrl(project.cloneUrl, it.commitId)
                +"${it.committerName} (${it.commitDate}) : "
                if (url.isNotBlank()) {
                    a(href = url, target = "_blank") { +it.commitMessage }
                } else {
                    +it.commitMessage
                }
            }
        }
    }
}

private fun RBuilder.errorMessage(buildResult: BuildResult) {
    if (buildResult.errorMessage.isNotBlank()) {
        p {
            +"Error message: "
        }
        code {
            +buildResult.errorMessage
        }
        br {} // TODO ALC line break doesn't work
    }
}
